export default {
  state: {
    charter: {
      enabled: false,
      pickup: {},
      startDate: '',
      endDate: '',
      datePicker: '',
      pax: 1,
      luggage: 0,
      MilitaryTimeWidget: 0,
      airportGeoId: '',
      selectedService: '',
      globalEnabled: false,
      maxDuration: 480
    }
  },
  mutations: {
    setCharterData (state, data) {
      for (let field in data) {
        state.charter[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/charter.js